import React, { useState } from 'react';
import {
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  TIME_ICON_RED, OFFER_STATUS, getDaysDiff,
} from '../../../../utils';

const getContractPendingDate = (artistDetail) => {
  const { timeLine } = artistDetail;
  const contractPending = timeLine.find((el) => [OFFER_STATUS.ADMIN_ACCEPTED, OFFER_STATUS.ARTIST_ACCEPTED].indexOf(el.status) > -1);
  return contractPending && getDaysDiff(contractPending.createdAt, new Date());
};
function OfferPriceUpdate(props) {
  const {
    updateOfferPrice, offerId, artistDetail, offerMaxDate,
  } = props;
  const [artistBasePrice, setArtistBasePrice] = useState(artistDetail.basePrice);

  return (
    <>
      <UncontrolledDropdown>
        {
        !(moment(new Date()).isAfter(offerMaxDate))
        && (
        <DropdownToggle>
          Update opportunity price
        </DropdownToggle>
        )
      }
        <DropdownMenu className="dropdown-theme">
          <div className="price-update-box">
            <Input
              type="number"
              value={artistBasePrice}
              onChange={(e) => setArtistBasePrice(e.target.value)}
            />
            <DropdownItem
              disabled={artistBasePrice < 0}
              onClick={() => updateOfferPrice({ variables: { offerId, artistId: artistDetail._id, basePrice: +artistBasePrice } })}
            >
              save
            </DropdownItem>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
      <span
        className="pending-error"
      >
        <img src={TIME_ICON_RED} alt="Contract" />
        {`Contract pending since ${getContractPendingDate(artistDetail)}d`}
      </span>
    </>
  );
}

OfferPriceUpdate.propTypes = {
  updateOfferPrice: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  offerMaxDate: PropTypes.string.isRequired,
  artistDetail: PropTypes.shape({
    artistImage: PropTypes.string,
    _id: PropTypes.string,
    basePrice: PropTypes.number,
  }).isRequired,
};

export default React.memo(OfferPriceUpdate);
